import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=932ef164"
import script from "./activate.vue?vue&type=script&lang=js"
export * from "./activate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('932ef164')) {
      api.createRecord('932ef164', component.options)
    } else {
      api.reload('932ef164', component.options)
    }
    module.hot.accept("./activate.vue?vue&type=template&id=932ef164", function () {
      api.rerender('932ef164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/activate.vue"
export default component.exports